import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemAgitation() {
  const painPoints = ['Te llega una notificación al DFE y se te hiela la sangre sin saber si es grave o no', 'Facturás sin saber cuánto te falta para saltar de categoría o quedar excluido de oficio', 'Te descuentan plata en cada transferencia y no sabés si podés recuperarla', 'Dejás los pesos quietos mientras la inflación los come día a día', 'Usás Mercado Pago sin saber que cada movimiento queda registrado en AFIP'];
  return <section className="py-16 px-4 sm:px-6 lg:px-8 bg-[#FAF5EC]" data-id="element-155">
      <div className="max-w-4xl mx-auto" data-id="element-156">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-center mb-8 text-[#1A1A1A]" data-id="element-157">
          ¿Cuántas noches más vas a quedarte despierto pensando en AFIP?
        </h2>

        <div className="space-y-6 mb-10 text-lg text-[#6B7280] leading-relaxed" data-id="element-158">
          <p data-id="element-159">
            Sos trabajador independiente. Querés progresar. Pero nadie te dijo
            que iba a ser así.
          </p>
          <p data-id="element-160">
            Que ibas a mirar el resumen del banco y ver retenciones que no
            pediste. Que ibas a facturar bien once meses y en el doceavo superar
            el tope sin darte cuenta. Que ibas a recibir una notificación de
            AFIP a las 10 de la noche sin saber si es grave.
          </p>
          <p className="font-semibold text-[#1A1A1A]" data-id="element-161">
            No es falta de esfuerzo. Es falta de un sistema.
          </p>
        </div>

        <div className="bg-white border border-[#EAE5DC] border-l-4 border-l-[#E85D5D] shadow-sm rounded-lg p-8 mb-10" data-id="element-162">
          <div className="space-y-4" data-id="element-163">
            {painPoints.map((point, index) => <div key={index} className="flex items-start gap-3" data-id="element-164">
                <XCircleIcon className="w-6 h-6 text-[#E85D5D] flex-shrink-0 mt-0.5" data-id="element-165" />
                <p className="text-[#1A1A1A] font-medium" data-id="element-166">{point}</p>
              </div>)}
          </div>
        </div>

        <p className="text-2xl sm:text-3xl font-bold text-center text-[#5BB4A0] italic" data-id="element-167">
          ¿Y si esta fuera la última semana que vivís así?
        </p>
      </div>
    </section>;
}